import { ThunkAction } from "redux-thunk";
import { RootState } from "../../store";
import { AnyAction } from "redux";
import UserCustomersService from "../../services/userManagement/userCustomers";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../actionsCreators/messageActions";
import { DELETE_USER_SUCCESS } from "../../lib/constants";

export const deleteUserCustomer =
  (id: string): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const response = await UserCustomersService.remove(id);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));
      return await Promise.resolve(response);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
